import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaCheck, FaRocket, FaLaptopCode, FaMedal, FaUserTie, FaMobileAlt, FaComments, FaPencilRuler, FaCode, FaUsers, FaEuroSign, FaShieldAlt, FaClock, FaSearch, FaLightbulb, FaLock, FaCalendarAlt } from 'react-icons/fa';
import Button from '../../components/Button';

const WebPymesPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: '/servicios/diseno-web-autonomos', text: 'Páginas web baratas para autónomos' },
    { url: '/servicios/diseno-web-empresas', text: 'Páginas web baratas para empresas' },
    { url: '/servicios/diseno-web-abogados', text: 'Páginas web baratas para abogados' },
    { url: '/servicios/diseno-web-inmobiliarias', text: 'Páginas web baratas para inmobiliarias' },
    { url: '/precios', text: 'Ver todos nuestros precios' },
    { url: '/proceso', text: 'Conoce nuestro proceso de trabajo' },
  ];
  
  // Lista de beneficios adaptados al buyer persona
  const benefits = [
    {
      title: "Ventas mientras duermes: tu negocio abierto 24/7",
      description: "Mientras tu tienda física está cerrada, tu web sigue generando contactos y ventas. Imagina despertar con pedidos que llegaron durante la noche."
    },
    {
      title: "Inversión mínima, retorno máximo",
      description: "Con solo 200€ de inversión inicial, consigues un canal de ventas permanente. Un solo cliente nuevo ya paga la web. ¿Cuántos clientes nuevos podrías conseguir este año?"
    },
    {
      title: "Tu competencia ya está online (y se lleva tus clientes)",
      description: "Sin web, pierdes a los clientes que te buscan en Google. Ellos encuentran a tu competencia, no a ti. Y nunca sabrás cuántas ventas has perdido."
    },
    {
      title: "Diferénciate de negocios similares",
      description: "Muchas pequeñas empresas tienen webs anticuadas o inexistentes. Una web moderna y profesional te hará destacar inmediatamente, generando más confianza y ventas."
    },
    {
      title: "Sin dolores de cabeza técnicos",
      description: "Te entregamos la web lista para usar. Sin necesidad de aprender tecnologías complicadas, sin lidiar con servidores o códigos extraños. Todo funciona desde el primer día."
    },
    {
      title: "Que tu tamaño no te limite",
      description: "Una web profesional te permite competir con empresas mucho más grandes que la tuya. Tus clientes valorarán tu servicio personalizado, pero con la imagen de una gran empresa."
    }
  ];
  
  // Características adaptadas a las preocupaciones de José
  const features = [
    {
      icon: <FaUsers />,
      title: "Diseñada para convertir visitas en ventas",
      description: "Tu web no será un simple folleto digital. Cada elemento está pensado para guiar al visitante hacia el contacto o la compra, maximizando el retorno de tu inversión."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en cualquier dispositivo",
      description: "El 70% de tus clientes verán tu web en el móvil. Tu web se adaptará perfectamente a cualquier pantalla, sin elementos rotos ni textos ilegibles que ahuyenten clientes."
    },
    {
      icon: <FaClock />,
      title: "Lista en solo 7 días",
      description: "No esperes meses para ver resultados. En solo una semana tendrás tu web funcionando y captando clientes. Cada día que pasa sin web son clientes perdidos."
    },
    {
      icon: <FaEuroSign />,
      title: "Costo fijo y transparente",
      description: "Sin presupuestos confusos, sin costes ocultos, sin 'extras' sorpresa al final. Pagas exactamente lo que acordamos desde el principio: desde 200€ por tu web y 20€/mes de mantenimiento."
    },
    {
      icon: <FaShieldAlt />,
      title: "Segura y conforme a la ley",
      description: "Incluimos todos los textos legales necesarios (RGPD, cookies, aviso legal...) y protección técnica para que no debas preocuparte por multas o problemas de seguridad."
    },
    {
      icon: <FaRocket />,
      title: "Posicionada para que te encuentren",
      description: "Tu web estará optimizada para aparecer en Google cuando tus clientes busquen tus productos o servicios. Sin trucos complicados ni falsas promesas, solo trabajo técnico bien hecho."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para PYMEs que necesitan una web sencilla pero profesional para comenzar su presencia online.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=pyme-basica',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por PYMEs. Equilibrio perfecto entre precio y funcionalidades para atraer más clientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=pyme-profesional',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para PYMEs que necesitan destacar en un mercado competitivo con más funcionalidades y mejor posicionamiento.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=pyme-avanzada',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Reunión inicial sin compromiso",
      description: "Hablamos sobre tu negocio, tus objetivos y cómo podemos ayudarte. Te explicamos todo en lenguaje claro, sin jerga técnica, y resolvemos todas tus dudas antes de empezar.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Creación de tu web en 7 días",
      description: "Diseñamos y desarrollamos tu web en tiempo récord, manteniéndote informado del progreso. Antes de finalizar, te mostramos la web para que puedas solicitar ajustes si lo necesitas.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y primeros resultados",
      description: "Activamos tu web y te enseñamos cómo sacarle el máximo partido. Te explicamos cómo funcionan las estadísticas y qué puedes esperar en las próximas semanas en términos de visitas y contactos.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Precios claros sin costes ocultos",
      us: true,
      others: false
    },
    {
      label: "Entrega en solo 7 días",
      us: true,
      others: false
    },
    {
      label: "Webs que realmente generan clientes",
      us: true,
      others: false
    },
    {
      label: "Sin permanencia obligatoria",
      us: true,
      others: false
    },
    {
      label: "Atención directa sin intermediarios",
      us: true,
      others: false
    },
    {
      label: "Explicaciones en lenguaje sencillo",
      us: true,
      others: false
    }
  ];
  
  // Testimonio centrado en las preocupaciones de José
  const testimonial = {
    text: "Siempre pensé que una web decente costaría miles de euros, por eso nunca di el paso. Con Web a Bajo Coste conseguí una página profesional a un precio razonable, sin sorpresas ni complicaciones. El primer mes ya recibí 5 contactos de clientes que encontraron mi negocio en Google.",
    author: "María Jiménez",
    position: "Propietaria",
    company: "Papelería Jiménez",
    avatar: "/servicios/testimonios/pyme.webp"
  };
  
  // FAQs específicas para las preocupaciones de PYMEs
  const faqs = [
    {
      question: "¿Una web barata realmente puede generar ventas para mi PYME?",
      answer: "Absolutamente. El precio de la web no determina su efectividad, sino la estrategia detrás de ella. Nuestras webs están diseñadas específicamente para convertir visitas en ventas o contactos, con elementos estratégicos como llamadas a la acción claras, testimonios de clientes y formularios de contacto accesibles. Tenemos decenas de pequeñas empresas que consiguieron nuevos clientes desde la primera semana de lanzamiento de su web.",
      category: "Resultados"
    },
    {
      question: "¿Cómo me aseguro de que la inversión valdrá la pena?",
      answer: "Piénsalo así: si tu web te consigue un solo cliente de 200€ o más, ya has recuperado tu inversión inicial. Con la cuota mensual, necesitarías un cliente de 20€ al mes para cubrirla. La mayoría de nuestros clientes consiguen múltiples contactos mensuales que superan ampliamente este valor. Además, trabajamos con precios finales y transparentes (desde 200€ por la web y 20€/mes de mantenimiento) para que sepas exactamente cuánto vas a pagar.",
      category: "Inversión"
    },
    {
      question: "No tengo conocimientos técnicos, ¿podré gestionar la web?",
      answer: "Precisamente diseñamos nuestras webs pensando en personas sin conocimientos técnicos. Te entregaremos un sitio web que no necesitará mantenimiento técnico por tu parte. Para pequeñas actualizaciones de contenido, te enseñaremos lo básico o podrás pedírnoslo directamente a nosotros. No necesitarás aprender a programar ni gestionar complicados paneles de administración.",
      category: "Uso"
    },
    {
      question: "¿Qué pasa si no me gusta el resultado final?",
      answer: "Antes de finalizar el proyecto, te mostraremos la web para que puedas solicitar ajustes si algo no te convence. No lanzamos nada sin tu aprobación. Además, incluimos hasta dos rondas de cambios durante el proceso para asegurarnos de que el resultado final cumpla tus expectativas. Nuestra prioridad es tu satisfacción, porque sabemos que un cliente satisfecho es nuestra mejor publicidad.",
      category: "Proceso"
    },
    {
      question: "¿Por qué elegiría vuestra web barata en lugar de usar Wix o WordPress?",
      answer: "Las plataformas gratuitas o económicas como Wix o WordPress tienen limitaciones importantes: rendimiento más lento, problemas de posicionamiento en Google, y una apariencia que a menudo grita 'plantilla barata'. Además, requieren tu tiempo para aprender a usarlas. Nosotros creamos webs profesionales con código limpio, mayor velocidad de carga y mejor posicionamiento, completamente personalizadas para tu negocio, sin que tengas que dedicar tiempo a aprender nuevas herramientas.",
      category: "Comparativa"
    },
    {
      question: "¿Cómo sé que mi web no se quedará obsoleta en unos meses?",
      answer: "Las tecnologías que usamos (React) son las mismas que utilizan gigantes como Facebook o Airbnb, lo que garantiza que tu web seguirá siendo moderna durante años. Además, la cuota mensual de mantenimiento incluye actualizaciones técnicas periódicas para mantener tu web segura y funcional. Si en el futuro necesitas funcionalidades nuevas, podemos implementarlas a precios razonables sin necesidad de rehacer toda la web desde cero.",
      category: "Futuro"
    }
  ];

  const founderMessage = "Después de trabajar con más de 100 pymes, descubrimos que lo que realmente necesitan no son webs complicadas y caras, sino soluciones efectivas, rápidas y sin complicaciones técnicas. Creamos Web a Bajo Coste precisamente para ofrecer webs profesionales que generen clientes sin arruinar a pequeños empresarios.";

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para PYMES
      pageTitle="Página Web Barata para PYMES | Desde 200€ con Resultados Garantizados"
      pageDescription="Crea tu página web profesional para PYMES desde solo 200€. Diseño que genera clientes reales, sin costes ocultos y lista en 7 días. Optimizada para ventas y contactos."
      pageKeywords="página web barata, web para pymes, diseño web económico, web pequeñas empresas, web profesional barata"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-pymes"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para pymes desde 200€ (sin sorpresas ni permanencia)"
      heroSubtitle="Diseño web profesional para pequeñas y medianas empresas. Presencia online sólida, optimizada para SEO y adaptada a tus necesidades. Soporte incluido."
      heroImage="/servicios/tipo-cliente/pymes-hero.webp"
      badges={['Desde 200€ (pago único)', 'Optimizada para SEO', 'Adaptable a móviles', 'Mantenimiento 20€/mes']}
      heroCTAText="Reservar consulta gratuita"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de PYME"
      pricingSubtitle="Elige el plan que mejor se adapte a tu empresa. Todos incluyen soporte técnico y mantenimiento obligatorio por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras webs son perfectas para tu pequeña empresa?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Miguel Vela"
            founderTitle="Co-fundador y Director de Desarrollo"
            avatarSrc="/sobre nosotros/foto-miguel.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Así creamos tu web: simple, rápido y sin complicaciones"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué las PYMEs nos eligen frente a otras opciones?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirá tu PYME con una web profesional?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes de pequeñas empresas"
      faqCategories={["Resultados", "Inversión", "Uso", "Proceso", "Comparativa", "Futuro"]}
      faqs={faqs}
      
      ctaTitle="Es el momento de digitalizar tu pequeña empresa"
      ctaDescription="Cada día sin web pierdes clientes potenciales. Comienza a captar nuevos clientes por internet con una inversión mínima."
      ctaButtonText="Reservar consulta gratuita"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebPymesPage; 

